export default function (tns) {
  const sliders = Array.from(
    document.querySelectorAll(
      '.FeaturedContent .tns-gallery:not(.ArticleContent .FeaturedContent .tns-gallery, .PageMain--great-pet-picks .FeaturedContentTop .tns-gallery, .PageMain--home .FeaturedContent--home .tns-gallery)'
    )
  )

  const slidersInSingle = Array.from(
    document.querySelectorAll('.ArticleContent .FeaturedContent .tns-gallery')
  )

  sliders.forEach((slider) =>
    applyTinySlideConfigs(
      slider,
      {
        0: {
          gutter: 0,
          items: 1,
        },
        640: {
          items: 2,
        },
        768: {
          items: 3,
        },
        1024: {
          items: 4,
        },
      },
      tns
    )
  )

  slidersInSingle.forEach((slider) =>
    applyTinySlideConfigs(
      slider,
      {
        0: {
          gutter: 0,
          items: 1,
        },
        640: {
          items: 2,
        },
        768: {
          items: 3,
        },
      },
      tns
    )
  )
}

function applyTinySlideConfigs(slider, responsive, tns) {
  return tns({
    container: slider,
    gutter: 0,
    nav: false,
    autoHeight: true,
    items: 1,
    edgePadding: 0,
    loop: false,
    preventScrollOnTouch: 'force',
    responsive: responsive,
  })
}
